import AssignmentIcon from '@mui/icons-material/Assignment';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import InfoIcon from '@mui/icons-material/Info';
import InsightsIcon from '@mui/icons-material/Insights';
import { ThemeProvider } from '@mui/material/styles';
import { getTheme } from '@parsys/frontend_library';
import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import PatientSidePanel from './PatientSidePanel';
import ErrorFallback from 'FRONTEND/components/ErrorFallback';
import PatientProfile from 'FRONTEND/components/PatientProfile';
import { mounted, unmounted } from 'FRONTEND/reducers/sidePanelSlice';
import { THEME_APP_NAME } from 'FRONTEND/utils/constants';
import i18n from 'FRONTEND/utils/i18n';

export default (element, store) => {
  store.dispatch(mounted());

  const root = createRoot(element);
  const theme = getTheme({ app: THEME_APP_NAME, branding: window.branding });
  root.render(
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <PatientSidePanel
            links={[
              {
                label: element.dataset.adminLabel,
                href: element.dataset.adminHref,
                icon: <InfoIcon titleAccess={element.dataset.adminLabel} />,
              },
              {
                label: element.dataset.historyLabel,
                href: element.dataset.historyHref,
                icon: <AssignmentIcon titleAccess={element.dataset.historyLabel} />,
              },
              {
                label: element.dataset.filesLabel,
                href: element.dataset.filesHref,
                icon: <CloudDownloadIcon titleAccess={element.dataset.filesLabel} />,
              },
              {
                label: element.dataset.medicalRecordLabel,
                href: element.dataset.medicalRecordHref,
                icon: <CreateNewFolderIcon titleAccess={element.dataset.medicalRecordLabel} />,
              },
              {
                label: element.dataset.medicalFollowUpLabel,
                href: element.dataset.medicalFollowUpHref,
                icon: <InsightsIcon titleAccess={element.dataset.medicalFollowUpLabel} />,
              },
              {
                label: element.dataset.accessCodeLabel,
                href: element.dataset.accessCodeHref,
                icon: <AssignmentIcon titleAccess={element.dataset.accessCodeLabel} />,
              },
            ]}
          >
            <PatientProfile
              title={{
                label: element.dataset.titleLabel,
                href: element.dataset.titleHref,
              }}
              createLabel={element.dataset.createLabel}
              picture={element.dataset.picture}
              clientId={element.dataset.clientId}
              birthdate={element.dataset.birthdate}
              gender={element.dataset.gender}
              height={{
                value: element.dataset.heightValue,
                unit: element.dataset.heightUnit,
              }}
              weight={{
                value: element.dataset.weightValue,
                unit: element.dataset.weightUnit,
              }}
              bmiLine={{
                label: i18n._('BMI'),
                value: element.dataset.bmiValue,
              }}
              tenantName={element.dataset.tenantName}
              workflows={element.dataset.workflows ? JSON.parse(element.dataset.workflows) : []}
              share={{
                label: element.dataset.shareLabel,
                href: element.dataset.shareHref,
              }}
            />
          </PatientSidePanel>
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>,
  );

  return () => {
    store.dispatch(unmounted());
    root.unmount();
  };
};
